import BaseUseCase from "../../base_use_case.js";

class SaveDownloadableUseCase extends BaseUseCase {

  execute(identifier, params) {
    let url = identifier ? `/api/v1/admin/downloadables/downloadables/${identifier}` : `/api/v1/admin/downloadables/downloadables`;

    let wrappedParams = this.wrapParams(params, "downloadable");
    wrappedParams.findBySlug = true;

    return this.httpClient({
      ...this.requestConfig(),
      method: identifier ? "put" : "post",
      url: url,
      data: wrappedParams,
    });
  }
}

const instance = new SaveDownloadableUseCase();
export default instance;
